import staticErrorMessages from 'features/cart/desktop/errorMessages';
import { showCartErrorMessage } from 'features/cart/desktop';
import { trackCartActions } from 'features/cart';
import { addClassDuringActivity } from 'utilities/dom';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { GetCartLink, DeleteCurrentCart } from '../../api';
import { cart, cartModel } from '../config';
import CartBaseLayoutView from '../../baseViews/LayoutView';
import DeleteCartPromptView from '../shared/DeleteCartPromptView';
import OverviewHeaderViewTemplate from '../templates/OverviewHeaderViewTemplate';

import ViewMoodBoard from './ViewMoodBoard';
import PrintCartLink from './PrintCartLink';

// TODO: Split into separate views, reuse views about email, etc
const OverviewHeaderView = CartBaseLayoutView.extend({
	JSXTemplate: OverviewHeaderViewTemplate,
	regions: {
		printCartLinkOverviewHeader: '#regionPrintCartLinkOverviewHeader',
		viewMoodBoardTop: '#regionViewMoodBoardTop'
	},
	className: 'cartOptionsContainer',
	ui: {
		cartOptions: 'select.cartOptions',
		cartShare: '.jsCartLink',
		customerInfoBtnContainer: '.customerInfoBtnContainer',
		email: '.jsEmail'
	},
	events: {
		'change select.cartOptions': 'selectCartOption',
		'click .cartOptions button': 'selectCartOption',
		'click @ui.email': 'onEmailClick',
		'click @ui.cartShare': 'onCartShare'
	},
	templateHelpers () {

		const helpers = {
			showCartLink: window.lp.cart.showCartLink && !window.lp.globals.isKiosk,
			isCustomerService: window.lp.globals.isCustomerService,
			showSkuOnTheFly: cart.showSkuOnTheFly,
			showAddRecommendedBulbOption: cartModel.get('ShowAddRecommendedBulbOption'),
			hideViewMoodBoard: this.shouldHideViewMoodBoard()
		};

		return helpers;

	},
	initialize () {

		this.listenTo(cartModel, 'change:ProductItems', () => {

			this.renderViewMoodBoard();
			this.toggleViewMoodBoard();

		});

		if (cartModel.get('IsMultipleShippingAddressMode') && this.ui.customerInfoBtnContainer.remove) {

			this.ui.customerInfoBtnContainer.remove();

		}

	},
	onRender () {

		this.showChildView('printCartLinkOverviewHeader', new PrintCartLink());
		this.renderViewMoodBoard();

	},
	onAttach () {

		const copyLinkBtn = document.querySelector('.copyCartLink');
		if (copyLinkBtn) {

			copyLinkBtn.addEventListener('click', () => {

				if (window.navigator.clipboard) {

					const cartLinkEl = document.getElementById('cartLink');
					const cartLink = cartLinkEl.value;

					// We shouldn't use document.execCommand('copy') as it is deprecated
					window.navigator.clipboard.writeText(cartLink).then(
						() => {

							copyLinkBtn.innerText = 'Copied!';

						},
						() => {

							console.error('Clipboard write failed due to lack of permission.');

						}
					);

				} else {

					console.error('Clipboard API not supported.');

				}

				trackCartActions({
					event_action: 'Copy-Employee-Cart-Link'
				});

			});

		}

	},
	renderViewMoodBoard () {

		if (!this.shouldHideViewMoodBoard()) {

			this.showChildView(
				'viewMoodBoardTop',
				new ViewMoodBoard({
					model: cartModel,
					moodBoardLabel: 'Mood Board'
				})
			);

		}

	},
	shouldHideViewMoodBoard () {
		const hideMoodBoard = window.utag_data.is_kiosk !== '1';
		return cartModel.get('ProductItems')?.filter((p) => p.CanUseMoodBoard).length === 0 || hideMoodBoard;

	},
	toggleViewMoodBoard () {

		if (!this.viewMoodBoardTop.hasView()) {

			return;

		}

		if (this.shouldHideViewMoodBoard()) {

			this.viewMoodBoardTop.el.classList.add('hidden');

		} else {

			this.viewMoodBoardTop.el.classList.remove('hidden');

		}

	},
	selectCartOption (e) {

		const that = this;
		const $target = e.target.tagName === 'SPAN' ? $(e.target).parents('a') : $(e.target);
		const option = this.ui.cartOptions.val() || $target.attr('data-option');

		if (this[option]) {

			this[option]();

			// reset dropdown
			setTimeout(() => {

				that.ui.cartOptions.val('-1');

			}, 1000);

		}

		e.preventDefault();

	},
	import () {

		trackCartActions({ event_action: 'click-Employee-Import' });

		if (window.lp.globals.isEmployeeConnectedAsCustomer) {

			$(cart).trigger('selectCartToImport');

		} else {

			window.location.href = '/connectascustomer/assetsearch?sourcepage=cart';

		}

	},
	delete () {

		trackCartActions({ event_action: 'click-Employee-Delete' });

		const deleteCartPromptView = new DeleteCartPromptView({
			el: $('#lpModalContainer'),
			viewOptions: {
				promptText: 'Are you sure you want to delete this cart?',
				onDelete () {

					const request = DeleteCurrentCart().then((response) => {

						if (response.operationSuccess) {

							window.location.href = '/';

						} else {

							showCartErrorMessage({
								response,
								fromModal: true
							});

						}

					});

					$(cart).trigger('indicateLoad', request);

				}
			}
		});
		deleteCartPromptView.render();

	},
	info () {

		trackCartActions({ event_action: 'click-Employee-Customer-Info' });

		$(cart).trigger('toggleCustomerInfoForm');

	},
	onEmailClick (e) {

		e.preventDefault();

		$('body').lpModal({
			appendContentToForm: false,
			src: '/cart/emailcart/',
			lpModalClass: 'lpModal--alt1',
			onInit: true,
			width: 496
		});

		setGenericEvent({ event_name: 'cart_email_click' });

	},
	onCartShare (e) {

		e.preventDefault();
		trackCartActions({
			event_action: 'Click-Employee-Cart-Link'
		});

		const toggleCartLink = (show, errorMessage) => {

			const mainEl = document.querySelector('.cartShareContainer__main');
			const errorEl = document.querySelector('.cartShareContainer__error');

			if (show) {

				mainEl.classList.remove('hidden');
				errorEl.classList.add('hidden');

			} else {

				errorEl.textContent = errorMessage;
				errorEl.classList.remove('hidden');
				mainEl.classList.add('hidden');

			}

		};
		const cartShareModal = document.getElementById('cartShareModal');
		const closeEvt = () => {

			const copyLinkBtn = document.querySelector('.copyCartLink');

			if (copyLinkBtn) {

				copyLinkBtn.innerText = 'Copy Link';

			}

			trackCartActions({
				event_action: 'Close-Employee-Cart-Link'
			});

		};

		$('body').lpModal({
			onInit: true,
			appendContentToForm: false,
			content: $(cartShareModal),
			height: 175,
			width: 500,
			openEvt: () => {

				const secondaryEmployeeNum = Number(document.getElementById('secondaryEmployeeNumber').value) || 0;
				const request = GetCartLink(secondaryEmployeeNum)
					.then((cartLink) => {

						if (cartLink) {

							document.getElementById('cartLink').value = `${window.lp.globals.secureSiteURL}${cartLink}`;
							toggleCartLink(true);

						} else {

							toggleCartLink(false, 'There are no items that can be shared in your cart.');

						}

					})
					.catch(() => {

						toggleCartLink(false, staticErrorMessages[0]);

					});

				addClassDuringActivity(cartShareModal, 'loading delayLoading', request);
				setTimeout(() => cartShareModal.classList.remove('delayLoading'), 1000);

			},
			closeEvt
		});

	}
});

export default OverviewHeaderView;
